import React, { useState } from 'react';
import ITripPayment from "@/models/trip-payments/itrip-payment";
import DatePickerComponent from "./date-picker";
import * as tripPaymentsService from '@/services/trip-payments-service';
import { toast } from "react-toastify";
import ISelectOption from "@/models/generic/iselect-option";
import fixCurrencyValue from "@/common/fix-currency-values";
import { isStringEmpty } from "@/common/validation-checkers";
import { TripPaymentHasRequiredFormFields } from "./validation";

interface IProps {
    guestId?: number;
    tripId?: number;
    paymentMethods: ISelectOption[];
    defaultNewDate?: Date;
    close: (requiresUpdate: boolean, tripPayment?: ITripPayment) => void;
}

const AddTripPayment: React.FC<IProps> = ({ guestId, tripId, paymentMethods, defaultNewDate, close }) => {

    const [ tripPayment, setTripPayment ] = useState<ITripPayment>({paymentDate: defaultNewDate ?? new Date()} as ITripPayment);
    
    async function AddTripPayment() {
        if (TripPaymentHasRequiredFormFields(tripPayment)) {

            if (!tripId) {
                const payment = {
                    ...tripPayment,
                    id: 0-Date.now(),
                    amount: fixCurrencyValue(tripPayment.amount)
                } as ITripPayment;

                close(false, payment);
                return;
            }

            const add = async () => {
                return await tripPaymentsService.addTripPayment({
                    ...tripPayment,
                    guestId: guestId,
                    tripId: tripId
                });
            }

            const response = await toast.promise(
                add(),
                {
                    pending: 'Adding guest payment',
                    success: 'Guest payment added',
                    error: 'Something went wrong whilst adding the guest payment'
                }
            );

            if (response) {
                close(true);
            }
        } 
    }

    function CancelAddingTripPayment() {
        close(false);
    }

    function submitForm(event: React.KeyboardEvent<HTMLTableRowElement>) {
        if (event.keyCode === 13 || event.key === "Enter") {
            AddTripPayment();
        }
    }

    return (
        <tr className="bg-gray-100" onKeyUp={submitForm} >
            <td>
                <DatePickerComponent
                    value={tripPayment.paymentDate}
                    newValue={(newValue) => setTripPayment({...tripPayment, paymentDate: newValue} as ITripPayment)} 
                />
            </td>
            <td>
                <input 
                    autoFocus
                    tabIndex={2}
                    type="number" 
                    placeholder="Amount"
                    className="pl-2 w-full"
                    onChange={(event) => setTripPayment({...tripPayment, amount: Number(event.target.value)} as ITripPayment)} 
                />
            </td>
            <td>
                <select 
                    tabIndex={3}
                    className="w-full px-2"
                    value={tripPayment?.methodId} 
                    onChange={(event) => setTripPayment({...tripPayment, methodId: isStringEmpty(event.target.value) ? undefined : Number(event.target.value)}  as ITripPayment)}
                    >
                    <option value={""}>
                        Please select
                    </option>

                    {paymentMethods.map(x => {
                        return (
                            <option key={x.id} value={x.id}>
                                {x.name}
                            </option>
                        );
                    })}
                </select>
            </td>
            <td className="text-right">
                <button title="Save" onClick={() => AddTripPayment()} className="bg-green-500 hover:brightness-110 text-white px-1 w-6"><i className="fa fa-check" /></button>
                <button title="Cancel" onClick={() => CancelAddingTripPayment()} className="mx-1 bg-red-600 hover:brightness-110 text-white px-1 w-6"><i className="fa fa-times" /></button>
            </td>
        </tr>
    )
}

export default AddTripPayment;